import { render, staticRenderFns } from "./verification-code-input.vue?vue&type=template&id=21ed0f64&scoped=true&"
import script from "./verification-code-input.vue?vue&type=script&lang=js&"
export * from "./verification-code-input.vue?vue&type=script&lang=js&"
import style0 from "./verification-code-input.vue?vue&type=style&index=0&id=21ed0f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed0f64",
  null
  
)

export default component.exports